"use client";

import { c as _c } from "react/compiler-runtime";
import { CharacterCount } from "@/components/Comment/components/form/CharacterCount.component";
import { CommentFormActions } from "@/components/Comment/components/form/CommentFormActions.component";
import { commentConfig } from "@/components/Comment/config/comment.config";
import { useCharacterCount } from "@/components/Comment/hooks/use-character-count.hook";
import { useCommentForm } from "@/components/Comment/hooks/use-comment-form.hook";
import { useTranslation } from "@/components/Translation/hooks/use-translation.hook";
import { Translation } from "@/components/Translation/Translation.component";
import { useViewportBreakpoint } from "@/hooks/browser/viewport/use-viewport-breakpoint.hook";
import type { CommentModel } from "@/services/api/comment/models/comment.model.types";
import { useAuthentication } from "@/vendors/authentication/hooks/use-authentication.hook";
type CommentFormProps = {
  // TODO: Remove when backend supports flatten on createComment
  readonly ancestorId?: string | null;
  readonly parent?: CommentModel.ParentReference | null;
  readonly onCancel?: () => void;
  readonly onSuccess?: () => void;
};
export function CommentForm(t0) {
  const $ = _c(38);
  const {
    parent,
    onSuccess,
    onCancel,
    ancestorId
  } = t0;
  let t1;
  if ($[0] !== ancestorId || $[1] !== onCancel || $[2] !== onSuccess || $[3] !== parent) {
    t1 = {
      ancestorId,
      onCancel,
      onSuccess,
      parent
    };
    $[0] = ancestorId;
    $[1] = onCancel;
    $[2] = onSuccess;
    $[3] = parent;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    formAction,
    formRef,
    handleCancel,
    isPending,
    textareaRef,
    uniqueId
  } = useCommentForm(t1);
  const {
    user: t2
  } = useAuthentication();
  const {
    user
  } = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      da: "Skriv din kommentar",
      de: "Schreibe deinen Kommentar",
      en: "Write your comment",
      no: "Skriv din kommentar",
      sv: "Skriv din kommentar"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const placeholder = useTranslation(t3);
  const {
    isMobile
  } = useViewportBreakpoint();
  const {
    charCount,
    handleChange,
    isAtLimit,
    maxLength
  } = useCharacterCount();
  const isReply = Boolean(parent);
  const textareaId = `comment-textarea-${uniqueId}`;
  const {
    rows
  } = commentConfig.form;
  const variant = isReply ? rows.reply : rows.root;
  const textareaRows = isMobile ? variant.mobile : variant.desktop;
  const t4 = isReply ? "Reply form" : "Comment form";
  const t5 = user?.fullName;
  let t6;
  if ($[6] !== t5) {
    t6 = <div className="flex items-center gap-1 border-smoke border-b p-2"><span className="font-medium text-nero text-sm">{t5}</span></div>;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Translation da="Din kommentar" de="Ihr Kommentar" en="Your comment" no="Din kommentar" sv="Din kommentar" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== textareaId) {
    t8 = <label className="sr-only" htmlFor={textareaId}>{t7}</label>;
    $[9] = textareaId;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== handleChange || $[12] !== isPending || $[13] !== maxLength || $[14] !== placeholder || $[15] !== textareaId || $[16] !== textareaRef || $[17] !== textareaRows) {
    t9 = <textarea className="w-full resize-y border-0 px-2 py-3 text-base text-charcoal placeholder:text-dim focus:outline-none focus:ring-0 sm:text-sm" disabled={isPending} id={textareaId} maxLength={maxLength} name="content" onChange={handleChange} placeholder={placeholder} ref={textareaRef} required={true} rows={textareaRows} />;
    $[11] = handleChange;
    $[12] = isPending;
    $[13] = maxLength;
    $[14] = placeholder;
    $[15] = textareaId;
    $[16] = textareaRef;
    $[17] = textareaRows;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== charCount) {
    t10 = charCount !== null ? <div className="flex justify-end border-smoke border-t px-2 py-1"><CharacterCount count={charCount} /></div> : null;
    $[19] = charCount;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t6 || $[23] !== t8 || $[24] !== t9) {
    t11 = <div className="border border-smoke bg-white">{t6}{t8}{t9}{t10}</div>;
    $[21] = t10;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  const t12 = onCancel ? handleCancel : undefined;
  let t13;
  if ($[26] !== isAtLimit || $[27] !== isPending || $[28] !== isReply || $[29] !== t12) {
    t13 = <CommentFormActions isAtLimit={isAtLimit} isPending={isPending} isReply={isReply} onCancel={t12} />;
    $[26] = isAtLimit;
    $[27] = isPending;
    $[28] = isReply;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== formAction || $[32] !== formRef || $[33] !== isPending || $[34] !== t11 || $[35] !== t13 || $[36] !== t4) {
    t14 = <form action={formAction} aria-busy={isPending} aria-label={t4} className="group flex flex-col gap-3" ref={formRef}>{t11}{t13}</form>;
    $[31] = formAction;
    $[32] = formRef;
    $[33] = isPending;
    $[34] = t11;
    $[35] = t13;
    $[36] = t4;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  return t14;
}